<template>
  <div>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="attributes"
      :items-per-page="10"
      dense
    >
      <template v-slot:item.actions="{ item }">
        <v-btn @click.stop="openEditDialog(item)" icon>
          <v-icon>mdi-square-edit-outline</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              small
              @click="deleteAttribute(item, null, clientPortal, partner)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Supprimer l'attribut</span>
        </v-tooltip>
      </template>
      <template v-slot:item.updatedAt="{ item }">
        {{ getInternationalDate(item.updatedAt) }}
      </template>
    </v-data-table>
    <edit-attribute-dialog
      :attribute="editedItem"
      :open.sync="openDialog"
      v-if="openDialog"
    ></edit-attribute-dialog>
  </div>
</template>
<script>
import { ref } from "@vue/composition-api";
import EditAttributeDialog from "@/components/Attribute/EditAttributeDialog";
import { useAttributes } from "@/composables/attribute";
import { date } from "@/composables/date";
export default {
  components: { EditAttributeDialog },
  props: {
    attributes: Array,
    isLoading: Boolean,
    firstLoad: Boolean,
    clientPortal: Object,
    partner: Object,
  },
  setup() {
    /* Import des API */
    const { deleteAttribute } = useAttributes();
    const { getInternationalDate } = date();

    const editedItem = ref({});
    const openDialog = ref(false);

    const openEditDialog = function (item) {
      editedItem.value = { ...item };
      openDialog.value = true;
    };

    return {
      headers: [
        { text: "Actions", value: "actions" },
        { text: "Clé", value: "name" },
        { text: "Valeur", value: "value" },
        { text: "Commentaire", value: "comment" },
        { text: "Mise à jour par", value: "updatedBy" },
        { text: "Date", value: "updatedAt" },
      ],
      deleteAttribute,
      getInternationalDate,
      openEditDialog,
      openDialog,
      editedItem,
    };
  },
};
</script>
